import React from 'react'

import classNames from 'classnames'

interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  label: React.ReactNode
  accentColor?: string
  required?: boolean
}

export default function Checkbox({
  checked,
  onChange,
  label,
  accentColor = '#0ea5e9',
  required = false,
}: CheckboxProps) {
  const checkboxClass = classNames(
    'w-5',
    'h-5',
    'rounded',
    'border-2',
    'border-gray-300',
    'cursor-pointer',
    'flex-shrink-0',
  )

  return (
    <label className="flex items-start gap-3 cursor-pointer mb-4">
      <div className="relative flex items-center justify-center mt-0.5">
        <input
          type="checkbox"
          checked={checked}
          onChange={e => onChange(e.target.checked)}
          className="sr-only"
        />
        <div
          className={checkboxClass}
          style={{
            backgroundColor: checked ? accentColor : 'transparent',
            borderColor: checked ? accentColor : '#d1d5db',
          }}
        >
          {checked && (
            <svg
              className="w-full h-full text-white p-0.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
                d="M5 13l4 4L19 7"
              />
            </svg>
          )}
        </div>
      </div>
      <span className="text-sm text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </span>
    </label>
  )
}
